// @flow

import HttpBackend from '../Services/HttpBackend'

export default class CrudModel {
  // entityName: string;
  // clazz: any;
  
  constructor(entityName: string, clazz: any) {
    // this.entityName = entityName;
    // this.clazz = clazz;
  }
  
  
  // static async get(entityName: string, id: string): CrudModel {
  //   const res = await HttpBackend.get(`/${entityName}/${id}`);
  //   console.log(typeof this);
  //   if(res.ok) {
  //     return this.clazz.create(res.data);
  //   }
  //   throw new Error(res.error);
  // }
  //
  // static async list(params?: any = {}): CrudModel {
  //   const res = await HttpBackend.get(`/${entityName}`, params);
  //   console.log(typeof this);
  //   if(res.ok) {
  //     return res.data.map(j => this.clazz.create(j));
  //   }
  //   throw new Error(res.error);
  // }
}


// WEBPACK FOOTER //
// ./src/App/Model/CrudModel.js